/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Meta_DescriptionInputs */

const ja_careers_meta_description = /** @type {(inputs: Careers_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイブレーン(PLAYBRAIN)は、現在積極的に募集をしています。ゲーム・eスポーツ業界を共に盛り上げたい方、是非ご応募ください。`)
};

const en_careers_meta_description = /** @type {(inputs: Careers_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN is actively recruiting. If you are passionate about the gaming and esports industry and want to help us elevate it, we encourage you to apply.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN is actively recruiting. If you are passionate about the gaming and esports industry and want to help us elevate it, we encourage you to apply." |
*
* @param {Careers_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const careers_meta_description = /** @type {((inputs?: Careers_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_meta_description(inputs)
	return en_careers_meta_description(inputs)
});